export const registrationProfiles = Object.freeze({
  professional: 'professionals',
  recruiter: 'recruiters',
  company: 'companies'
});

export function getRegistrationProfile(profileName = '') {
  return registrationProfiles[profileName] || null;
}
